<!-- TVG-360 section eleven (a and b): the contact's own journey, shown once,
     with the venues they are booked to view sitting directly beneath it. -->

@if (journey) {
  <div
    class="mb-3 rounded-2xl w-full border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]"
    data-testid="contact-journey-summary">
    <div class="flex flex-wrap items-baseline gap-x-3 gap-y-1 px-5 py-4 sm:px-6 sm:py-5">
      <h3 class="text-base font-medium text-gray-800 dark:text-white/90">Sales journey</h3>
      <p class="text-theme-xs text-gray-500 dark:text-gray-400">Where this contact is, across everything they have with us.</p>
    </div>

    <div class="border-t border-gray-100 px-5 py-4 dark:border-gray-800 sm:px-6">
      <div class="overflow-x-auto">
        <app-customer-journey-timeline [journey]="journey"></app-customer-journey-timeline>
      </div>

      <!-- Eleven b: one compact line, only when a viewing is actually booked. -->
      @if (bookedViewings.length) {
        <div
          class="mt-4 flex flex-wrap items-baseline gap-x-2 gap-y-1 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-theme-sm dark:border-gray-700 dark:bg-white/[0.03]"
          data-testid="contact-booked-viewings">
          <span class="font-medium text-gray-700 dark:text-gray-200">
            @if (bookedVenueCount > 1) {
              Viewing {{ bookedVenueCount }} venues:
            } @else {
              Viewing booked:
            }
          </span>
          @for (viewing of bookedViewings; track $index) {
            <span class="whitespace-nowrap text-gray-600 dark:text-gray-300">
              <a
                [routerLink]="['/events', viewing.event_id]"
                class="font-medium text-brand-600 hover:text-brand-700 dark:text-brand-400 dark:hover:text-brand-300">
                {{ viewing.venue?.name || 'Venue TBC' }}
              </a>
              <span class="text-gray-500 dark:text-gray-400">{{ formatShortDate(viewing.date) }}</span>
              @if (!$last) {
                <span aria-hidden="true" class="text-gray-300 dark:text-gray-600">·</span>
              }
            </span>
          }
        </div>
      }
    </div>
  </div>
}
